import React from 'react';

import { Container as ContainerUI, Item } from '@crehana/ui/dist/Grid';

const Container: React.FC = ({ children }) => {
  return (
    <ContainerUI>
      <Item position="1/1">{children}</Item>
    </ContainerUI>
  );
};

export default Container;
